import React from 'react';
import styled from 'styled-components';

const AboutSection = styled.section`
  padding: 80px 0;
  background-color: #f0f9ff;
`;

const SectionTitle = styled.h2`
  text-align: center;
  color: #6a1b9a;
  font-size: 36px;
  margin-bottom: 15px;
`;

const SectionSubtitle = styled.p`
  text-align: center;
  color: #666;
  font-size: 18px;
  margin-bottom: 50px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const Divider = styled.div`
  height: 4px;
  width: 80px;
  background: linear-gradient(to right, #00b8d4, #6a1b9a);
  margin: 0 auto 40px;
`;

const AboutContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 50px;
  
  @media (max-width: 992px) {
    flex-direction: column;
  }
`;

const AboutContent = styled.div`
  flex: 1;
`;

const AboutText = styled.p`
  color: #555;
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 20px;
`;

const AboutVideo = styled.div`
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  
  iframe {
    width: 100%;
    aspect-ratio: 16/9;
    border: none;
  }
`;

const AboutUs = () => {
  return (
    <AboutSection id="quem-somos">
      <SectionTitle>Quem Somos</SectionTitle>
      <SectionSubtitle>
        Clínica de Odontopediatria em [Sua Cidade]
      </SectionSubtitle>
      <Divider />
      
      <AboutContainer>
        <AboutContent>
          <AboutText>
            Fundado em [Ano], o Ateliê Dentinhos de Leite se destaca pela excelência técnica aliada ao cuidado com a família.
          </AboutText>
          <AboutText>
            No Ateliê Dentinhos de Leite, o sorriso do público infanto-juvenil é nossa prioridade! Somos referência por contarmos com uma equipe especializada e um ambiente acolhedor e divertido, transformamos visitas ao dentista em aventuras positivas.
          </AboutText>
          <AboutText>
            Proporcionamos saúde bucal com amor à ciência e aos pequenos, construindo laços de confiança. Aqui, cada sorriso recebe cuidado personalizado, desde os primeiros dentinhos até a adolescência.
          </AboutText>
          <AboutText>
            Venha vivenciar um novo conceito em Odontopediatria e proporcione um sorriso radiante para seu filho!
          </AboutText>
        </AboutContent>
        
        <AboutVideo>
          {/* Placeholder para vídeo institucional */}
          <iframe 
            src="about:blank" 
            title="Vídeo institucional do Ateliê Dentinhos de Leite" 
            allowFullScreen
          ></iframe>
        </AboutVideo>
      </AboutContainer>
    </AboutSection>
  );
};

export default AboutUs;
